import { render } from "./BrowserDetails.vue?vue&type=template&id=03534a61&scoped=true&ts=true"
import script from "./BrowserDetails.vue?vue&type=script&lang=ts"
export * from "./BrowserDetails.vue?vue&type=script&lang=ts"

import "./BrowserDetails.vue?vue&type=style&index=0&id=03534a61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03534a61"]])

export default __exports__